import React from 'react';
import NewDesign from 'components/NewDesign';
import { get, isEqual, omit } from 'lodash';
import { isDefine, isNumeric } from 'helpers';
import { CommonIcons } from 'components/Icons';
import UserModel from 'models/user.model';
import classNames from 'classnames';

const propTypes = {};

const BillingInfoComparison = ({ className, style, originalInfo, nextInfo }) => {
  //! State

  //! Function

  //! Render
  return (
    <div className={classNames('component:BillingInfoComparison', className)} style={style}>
      {Object.entries(omit(nextInfo, ['contactDataSize', 'deactivatedDate']))?.map((el) => {
        const [field, value] = el;
        const oldValue = get(originalInfo, field);

        const renderValue = () => {
          const prevVal = isNumeric(oldValue) ? Number(oldValue) : `${oldValue}`;
          const nextVal = isNumeric(value) ? Number(value) : `${value}`;
          const shouldShowArrow = isDefine(oldValue) && isDefine(value);
          const shouldShowOldValue = isDefine(oldValue);
          const shouldShowNewValue = isDefine(value);

          if (!isEqual(nextVal, prevVal)) {
            return (
              <div className='d-flex gap-4px align-items-center flex-wrap'>
                {shouldShowOldValue && (
                  <NewDesign.Typography className='color-danger-v2 text-decoration-line-through'>
                    {prevVal}
                  </NewDesign.Typography>
                )}
                {shouldShowArrow && <CommonIcons.ArrowRight />}
                {shouldShowNewValue && (
                  <NewDesign.Typography className='color-success-v2'>
                    {nextVal}
                  </NewDesign.Typography>
                )}
              </div>
            );
          }

          return <NewDesign.Typography>{value}</NewDesign.Typography>;
        };

        return (
          <div className='d-flex justify-content-between gap-12px hover:bg-color-hover-primary-v2'>
            <NewDesign.Typography className='flex-shrink-0' style={{ width: 230 }}>
              {UserModel.mappingLabelBillingInfo(field) || field || ''}
            </NewDesign.Typography>
            {renderValue()}
          </div>
        );
      })}
    </div>
  );
};

BillingInfoComparison.propTypes = propTypes;
export default BillingInfoComparison;
